// $ для встроенных скриптов доставок (блоки и шаблоны из БД) и модулей сайта (layout.js, main-slider.js,
// lib/*). Опрос 27 доставок 26.10.2026 нашёл четыре таких скрипта; им нужны только методы ниже. Методы
// повторяют jQuery 1.11.3 на этих вызовах. Обработчики событий получают событие браузера, а не объект
// события jQuery. Каждый обработчик ready — отдельный слушатель DOMContentLoaded: ошибка в одном
// не отменяет остальные (в jQuery 1.11 она отменяла все следующие).
const olddisplay = new WeakMap();
const cache = new WeakMap();
const handlers = new WeakMap();
const CSS_NUMBER = /^(columnCount|fillOpacity|flexGrow|flexShrink|fontWeight|lineHeight|opacity|order|orphans|widows|zIndex|zoom)$/;
const SWAP = { position: 'absolute', visibility: 'hidden', display: 'block' };

const camel = name => name.replace(/-([\da-z])/gi, (m, c) => c.toUpperCase());
const computed = el => el.ownerDocument.defaultView.getComputedStyle(el);
// Скрытый элемент для show, hide и toggle, как isHidden в jQuery: display: none у самого элемента или вне документа.
const isHidden = el => computed(el).display === 'none' || !el.ownerDocument.documentElement.contains(el);
// Без повторов и в порядке документа, как jQuery.unique.
const uniqueSort = list => list.filter((el, i) => list.indexOf(el) === i).sort((a, b) => (a.compareDocumentPosition(b) & 2 ? 1 : -1));

// Значение data-атрибута: логическое, null, число (если запись числа не меняется), JSON или строка.
function parseData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === 'null') return null;
    if (+value + '' === value) return +value;
    if (/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/.test(value)) {
        try { return JSON.parse(value); } catch (e) { return value; }
    }
    return value;
}

// display тега без классов, как defaultDisplay в jQuery. Если стили страницы скрывают сам тег,
// берётся block (jQuery в этом случае брал display браузера из пустого iframe).
function defaultDisplay(el) {
    const doc = el.ownerDocument;
    const probe = doc.body.appendChild(doc.createElement(el.nodeName));
    const display = computed(probe).display;
    probe.remove();
    return display === 'none' ? 'block' : display;
}

// Поля и рамки по сторонам со знаком минус: на них размер рамки больше размера содержимого.
function frame(el, name, styles) {
    let value = 0;
    (name === 'width' ? ['Right', 'Left'] : ['Top', 'Bottom']).forEach(side => {
        value -= parseFloat(styles['padding' + side]) || 0;
        value -= parseFloat(styles['border' + side + 'Width']) || 0;
    });
    return value;
}

function dispatch(el, list, event) {
    const queue = [];
    const delegated = list.filter(item => item.selector);
    if (delegated.length && !(event.button && event.type === 'click')) {
        for (let node = event.target; node && node !== el; node = node.parentNode) {
            if (node.nodeType !== 1 || (node.disabled === true && event.type === 'click')) continue;
            const matched = delegated.filter(item => node.matches(item.selector));
            if (matched.length) queue.push([node, matched]);
        }
    }
    if (delegated.length < list.length) queue.push([el, list.slice(delegated.length)]);
    queue.forEach(([node, items]) => {
        if (event.cancelBubble) return;
        items.forEach(item => {
            if (item.handler.call(node, event) === false) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    });
}

// Размер содержимого или рамки (outer), как .width() и .outerWidth() в jQuery. Элемент с display: none
// jQuery меряет показанным на время замера. Без размера рамки берётся вычисленный стиль.
function size(el, name, outer) {
    if (!el) return null;
    if (el === el.window) return el.document.documentElement[name === 'width' ? 'clientWidth' : 'clientHeight'];
    const measure = () => {
        const styles = computed(el);
        const box = name === 'width' ? el.offsetWidth : el.offsetHeight;
        if (box > 0) return outer ? box : box + frame(el, name, styles);
        const value = styles[name];
        if (/^[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)(?!px)[a-z%]+$/i.test(value)) return parseFloat(value);
        const base = parseFloat(value) || 0;
        if (styles.boxSizing === 'border-box') return outer ? base : base + frame(el, name, styles);
        return outer ? base - frame(el, name, styles) : base;
    };
    if (!/^(none|table(?!-c[ea]).+)/.test(computed(el).display) || el.offsetWidth !== 0) return measure();
    const old = {};
    Object.keys(SWAP).forEach(key => { old[key] = el.style[key]; el.style[key] = SWAP[key]; });
    try {
        return measure();
    } finally {
        Object.keys(SWAP).forEach(key => { el.style[key] = old[key]; });
    }
}

// Размер содержимого: у border-box к нему добавляются поля и рамки. null и NaN ничего не меняют.
function setSize(el, name, value) {
    if (value == null || value !== value) return;
    const styles = computed(el);
    const extra = styles.boxSizing === 'border-box' ? frame(el, name, styles) : 0;
    const match = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(.*)$/i.exec(typeof value === 'number' ? value + 'px' : value);
    el.style[name] = match ? Math.max(0, match[1] - extra) + (match[2] || 'px') : value;
}

export function createDollar(win) {
    const doc = win.document;

    class Collection {
        constructor(items) {
            this.length = 0;
            Array.prototype.forEach.call(items, item => { if (item != null) this[this.length++] = item; });
        }

        each(fn) {
            for (let i = 0; i < this.length; i++) {
                if (fn.call(this[i], i, this[i]) === false) break;
            }
            return this;
        }

        find(selector) {
            const found = [];
            this.each((i, el) => { found.push(...el.querySelectorAll(selector)); });
            return new Collection(this.length > 1 ? uniqueSort(found) : found);
        }

        closest(selector) {
            const found = [];
            this.each((i, el) => { found.push(el.closest ? el.closest(selector) : null); });
            const items = found.filter(Boolean);
            return new Collection(items.length > 1 ? uniqueSort(items) : items);
        }

        // До DOMContentLoaded обработчик ждёт его, после выполняется сразу, как в jQuery 1.11.
        ready(fn) {
            if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', () => fn.call(doc, $));
            else fn.call(doc, $);
            return this;
        }

        // Один слушатель на элемент и событие, как в jQuery: сначала делегированные обработчики
        // для элементов от цели события до элемента подписки, затем прямые. Список составляется
        // до вызовов. return false останавливает следующие элементы и действие по умолчанию.
        // Щелчок не левой кнопкой и щелчок по отключённому элементу делегированные обработчики не получают.
        on(types, selector, handler) {
            if (typeof selector === 'function') {
                handler = selector;
                selector = null;
            }
            return this.each((i, el) => {
                const byType = handlers.get(el) || {};
                handlers.set(el, byType);
                types.split(/\s+/).filter(Boolean).forEach(type => {
                    if (!byType[type]) {
                        byType[type] = [];
                        el.addEventListener(type, event => dispatch(el, byType[type], event));
                    }
                    const list = byType[type];
                    list.splice(selector ? list.filter(item => item.selector).length : list.length, 0, { selector, handler });
                });
            });
        }

        load(fn) {
            return this.on('load', fn);
        }

        attr(name, value) {
            if (value === undefined) {
                const result = this[0] && this[0].getAttribute ? this[0].getAttribute(name) : null;
                return result === null ? undefined : result;
            }
            return this.each((i, el) => el.setAttribute(name, value));
        }

        // Значение data-* читается один раз и запоминается. Нет атрибута — undefined без запоминания.
        data(key) {
            const el = this[0];
            if (!el || el.nodeType !== 1) return undefined;
            const values = cache.get(el) || {};
            cache.set(el, values);
            const name = camel(key);
            if (!(name in values)) {
                const raw = el.getAttribute('data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase());
                if (raw === null) return undefined;
                values[name] = parseData(raw);
            }
            return values[name];
        }

        // Числа получают px, кроме свойств без единиц. null и NaN ничего не меняют.
        css(name, value) {
            if (typeof name === 'object') {
                Object.keys(name).forEach(key => this.css(key, name[key]));
                return this;
            }
            const prop = camel(name);
            return this.each((i, el) => {
                if (value == null || value !== value) return;
                el.style[prop] = typeof value === 'number' && !CSS_NUMBER.test(prop) ? value + 'px' : value;
            });
        }

        // Встроенный display: none снимается. Скрытый стилями элемент получает display тега.
        show() {
            return this.each((i, el) => {
                if (!el.style) return;
                let value = olddisplay.get(el);
                if (!value && el.style.display === 'none') el.style.display = '';
                if (el.style.display === '' && isHidden(el)) olddisplay.set(el, value = defaultDisplay(el));
                if (el.style.display === 'none' || el.style.display === '') el.style.display = value || '';
            });
        }

        // Прежний display запоминается для show.
        hide() {
            return this.each((i, el) => {
                if (!el.style) return;
                const display = el.style.display;
                const hidden = isHidden(el);
                if ((display && display !== 'none') || !hidden) olddisplay.set(el, hidden ? display : computed(el).display);
                el.style.display = 'none';
            });
        }

        toggle() {
            return this.each((i, el) => (isHidden(el) ? $(el).show() : $(el).hide()));
        }

        width(value) {
            return value === undefined ? size(this[0], 'width') : this.each((i, el) => setSize(el, 'width', value));
        }

        height(value) {
            return value === undefined ? size(this[0], 'height') : this.each((i, el) => setSize(el, 'height', value));
        }

        outerWidth() {
            return size(this[0], 'width', true);
        }

        outerHeight() {
            return size(this[0], 'height', true);
        }
    }

    function $(selector) {
        if (typeof selector === 'function') return $(doc).ready(selector);
        if (typeof selector === 'string') {
            // #id jQuery ищет через getElementById: только первый элемент с этим id.
            if (/^#[\w-]*$/.test(selector)) return new Collection([doc.getElementById(selector.slice(1))]);
            return new Collection(selector ? doc.querySelectorAll(selector) : []);
        }
        if (selector && typeof selector.length === 'number' && selector !== selector.window && !selector.nodeType) {
            return new Collection(selector);
        }
        return new Collection(selector == null ? [] : [selector]);
    }

    return $;
}

export const $ = createDollar(window);
